import { helpers } from '../helpers.js';

var block_projects = {
    options: {
        // global options
    },

    selectors: {
        button: '.js-load-more-projects',
        projectItems: '.block-projects ul li'
    },

    init: function () {
        const self = this;
        self.loadMore();
    },

    loadMore: function () {
        const self = this;

        jQuery(self.selectors.button).on('click', function (e) {
            e.preventDefault();

            const $projects = jQuery(self.selectors.projectItems);
            const $hidden = $projects.filter('.d-none');

            // Show next 6 hidden items
            $hidden.slice(0, 6).removeClass('d-none');

            // Hide or disable the button if no more hidden items left
            if ($projects.filter('.d-none').length === 0) {
                jQuery(this).addClass( 'd-none' ); // or use `.prop('disabled', true);`
            }
        });
    }
}

// Export
export { block_projects };